module.exports = __webpack_public_path__ + "img/report3.793ffe7c.png";